import React, { useState } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import PackageComponent from "../components";
import {
  getPackages,
  deletePackage,
} from "../../../../services/Handlers/MasterPackageService";
import { useAuth } from "../../../../context/AuthProvider";
import { useNotification } from "../../../../context/NotificationProvider";
import { useLocalization } from "../../../../context/LocalizeContextProvider";
import { useModal } from "../../../../context/ModalProvider";
import { PER_PAGE_SIZE } from "../../../../utils/constants";

export default function Package() {
  const localize = useLocalization();
  const notification = useNotification();
  const modal = useModal();

  const { userDetail } = useAuth();
  const [dataPackage, setDataPackage] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [totalEntries, setTotalEntries] = useState(0);
  const [sizePerPage, setSizePerPage] = useState(PER_PAGE_SIZE);
  const [sortState, setSortState] = useState({ key: "", value: "" });

  const { isLoading, isFetching, refetch } = useQuery(
    ["PackageList", userDetail?.businessId, page, sizePerPage, sortState],
    () =>
      getPackages({
        businessId: userDetail?.businessId,
        page,
        size: sizePerPage,
        sortKey: sortState?.key,
        sortValue: sortState?.value,
      }),
    {
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          setDataPackage(res?.data.data || []);
          const total =
            res?.data?.pagination?.total ?? res?.data?.total ?? 0;
          const totalPages =
            res?.data?.pagination?.totalPages ??
            Math.ceil(total / sizePerPage);
          setTotalEntries(total);
          setTotalPage(totalPages);
        }
      },
      enabled: !!userDetail?.businessId,
    }
  );

  const { isLoading: isLoadingDelete, mutate: mutateDelete } = useMutation(
    deletePackage,
    {
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          modal.dismiss();
          refetch();
          notification.success(localize.getText("successDeleteData"));
        } else {
          notification.error(
            res?.data?.detail || localize.getText("unknownMessageError")
          );
        }
      },
      onError: (res) => {
        notification.error(localize.getText("unknownMessageError"));
      },
    }
  );

  const handlePagination = (value) => {
    setPage(value);
  };

  const handleSetSizePerPage = (size) => {
    setPage(0);
    setSizePerPage(size);
  };

  return (
    <PackageComponent
      dataPackage={dataPackage}
      isLoading={isLoading || isFetching || isLoadingDelete}
      mutateDelete={mutateDelete}
      totalPage={totalPage}
      totalEntries={totalEntries}
      activePage={page}
      handlePagination={handlePagination}
      handleSetSizePerPage={handleSetSizePerPage}
      sizePerPage={sizePerPage}
      sortState={sortState}
      setSortState={setSortState}
    />
  );
}
